import {IOpenOrder, IPosition} from '../types/portfolio'
import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IAsset {
    symbol: string
    name?: string
    amount: number
    avg_buy_price: number
    current_price: number
    price_in_base: number
    leverage: number
    side?: string
    cross_margin: boolean
    is_margin: boolean
    unrealised_pnl: number
    exchange: string
    is_edit: boolean
    key_id: string
    logo: string
    profit: number
    initial_value: number
    current_value: number
    pnl: number
    avg_entry_price: number
    is_base: boolean
    extra?: string

    key_name?: string //populated on client-side only
}

export interface ILatestBalance {
    id: string
    user_id: string
    key_id: string
    assets: IAsset[]
    current_position: IPosition[]
    total_amount_in_base: number
    exchange: string
    day_timestamp: number
    created_at: number
}

export interface IAssetSummary {
    initial_balance: number
    deposit: number
    withdraw: number
    earning: number
    profit: number
    start_at: string
    end_at: string
}

export interface IAssetSummaryByDuration {
    1: IAssetSummary
    1000: IAssetSummary
    30: IAssetSummary
}

export interface IKeyPortfolio {
    id: string
    key_name: string
    exchange: string
    created_at: string
    copier?: any
    latest_balance: ILatestBalance
    win: number
    loss: number
    mdd: number
    average_hold_seconds_per_month: number
    tf: number
    asset_summary: IAssetSummaryByDuration
    open_orders?: IOpenOrder[]
    is_copier?: boolean
    is_leader?: boolean
    user_id?: string
}

export interface IApiGetSidebarKeyIdProps extends IApiBaseProps {}

export interface IApiBaseProps {
    cookie?: any
}

export const apiGetKeyPortfolio = async (
    id: string,
    props?: IApiGetSidebarKeyIdProps,
): Promise<ApiRes<IKeyPortfolio>> => {
    return await apiGet(API_URL, `key/portfolio/${id}`, {cookies: props?.cookie})
}
